"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Pagination;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ellipsis = _interopRequireDefault(require("./pagination/ellipsis"));

var _item = _interopRequireDefault(require("./pagination/item"));

function Pagination({
  context: {
    group,
    slug,
    pages,
    current
  },
  className
}) {
  if (pages > 1) {
    const items = [];
    const start = Math.max(1, current - 2);
    const stop = Math.min(current + 2, pages - 1);

    if (pages > 2) {
      for (let i = start; i < stop; i++) {
        items.push( /*#__PURE__*/_react.default.createElement(_item.default, {
          group: group,
          slug: slug,
          current: current,
          page: i + 1,
          key: `pagination-item-${i}`
        }));
      }
    }

    return /*#__PURE__*/_react.default.createElement("nav", {
      className: (0, _classnames.default)("pagination", className),
      role: "navigation",
      "aria-label": "pagination"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "pagination-list"
    }, /*#__PURE__*/_react.default.createElement(_item.default, {
      group: group,
      slug: slug,
      current: current,
      page: 1
    }), start > 1 && /*#__PURE__*/_react.default.createElement(_ellipsis.default, null), items, stop < pages - 1 && /*#__PURE__*/_react.default.createElement(_ellipsis.default, null), pages > 1 && /*#__PURE__*/_react.default.createElement(_item.default, {
      group: group,
      slug: slug,
      current: current,
      page: pages
    })));
  } else {
    return null;
  }
}

Pagination.propTypes = {
  context: _propTypes.default.object.isRequired,
  className: _propTypes.default.string
};